<div *ngIf="type == 'image'" class="flex items-center justify-center h-full w-full bg-gray-300 animate-pulse">
  <svg class="w-10 h-10 text-gray-200" xmlns=" http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 20 18">
    <path d="M18 0H2a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h16a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2Zm-5.5 4a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3Zm4.376 10.481A1 1 0 0 1 16 15H4a1 1 0 0 1-.895-1.447l3.5-7A1 1 0 0 1 7.468 6a.965.965 0 0 1 .9.5l2.775 4.757 1.546-1.887a1 1 0 0 1 1.618.1l2.541 4a1 1 0 0 1 .028 1.011Z" />
  </svg>
</div>

<div *ngIf="type == 'text' || !type" class="h-2.5 bg-gray-200 rounded-full w-full"></div>

<div *ngIf="type == 'icon'" class="w-10 h-10 bg-gray-200 rounded-full"></div>

<div *ngIf="type == 'paragraph'" class="space-y-2.5 animate-pulse w-full">
  <div class="flex items-center w-full">
    <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-32"></div>
    <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
    <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
  </div>
  <div class="flex items-center w-full">
    <div class="h-2.5 bg-gray-200 rounded-full dark:bg-gray-700 w-full"></div>
    <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
    <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-24"></div>
  </div>
  <div class="flex items-center w-full">
    <div class="h-2.5 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
    <div class="h-2.5 ms-2 bg-gray-200 rounded-full dark:bg-gray-700 w-80"></div>
    <div class="h-2.5 ms-2 bg-gray-300 rounded-full dark:bg-gray-600 w-full"></div>
  </div>
</div>